<template>
  <v-autocomplete
    v-model="dealer"
    :items="dealerOptions"
    :menu-props="{ maxHeight: '400' }"
    @input.native="loadDealers()"
    :search-input.sync="dealerSearch"
    :label="label"
    item-text="name"
    persistent-hint
    color="primary"
    clearable
    autocomplete="off"
    no-filter
    return-object
    @change="handleChange"
    :disabled="disabled"
  >
    <template v-slot:item="{ item }">
      <span>
        {{ item.name }}
      </span>
      <v-spacer></v-spacer>
      <licence-chip
        v-if="item.special"
        :feature="assignOtherServicingPartnerToTaskHandler(item.crm_group)"
        :enabled="
          assignOtherServicingPartnerToTaskHandler(item.crm_group).enabled
        "
        float-direction="right"
      ></licence-chip>
    </template>
    <template v-slot:selection="{ item }">
      <span>
        {{ item.name }}
      </span>
    </template>
  </v-autocomplete>
</template>

<script>
import api from "@/utils/api";
import restrictions from "@/utils/restrictions";
import LicenceChip from "@/components/general/LicenceChip";
import { mapGetters } from "vuex";

export default {
  name: "DealerSelector",
  components: {
    LicenceChip,
  },
  props: {
    initialDealer: {
      type: Object,
      default: Object,
    },
    label: {
      type: String,
      default: String,
    },
    selectFirst: {
      type: Boolean,
      default: false,
    },
    tasks: {
      type: Boolean,
      default: false,
    },
    selectOther: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(["getBrandID", "assignOtherServicingPartnerToTaskHandler"]),
  },
  data: () => ({
    dealerOptions: [],
    dealerSearch: "",
    dealer: {},
    timeout: null,
  }),
  created() {
    this.setInitialData();
    this.loadDealers(true).then((resp) => {
      if (
        this.initialDealer !== null &&
        Object.keys(this.initialDealer).length !== 0
      ) {
        let dealer = this.dealerOptions.find((element) => {
          return element.uuid === this.initialDealer.uuid;
        });
        this.dealer = dealer;
      }

      if (this.selectOther) {
        this.dealer = this.dealerOptions[0];
      } else if (this.dealerOptions.length === 2) {
        this.dealer = this.dealerOptions.find((item) => {
          return item.uuid !== "other";
        });
      }

      if (this.dealer !== null && this.dealer !== undefined) {
        this.handleChange(this.dealer);
      }
    });
  },
  methods: {
    setInitialData() {
      this.dealerOptions = [
        {
          name: this.$t("components.selectors.taskDealerSelector.other"),
          uuid: "other",
          special: true,
          disabled: this.assignOtherServicingPartnerToTaskHandler().disabled,
        },
      ];
    },
    handleChange(value = {}) {
      if (Object.keys(value).length !== 0) {
        this.$emit("change", value);
        this.$emit("update:dealer-uuid", value.uuid);
      } else {
        this.$emit("change", null);
        this.$emit("update:dealer-uuid", "");
      }
    },
    loadDealers(initalLoad = false) {
      let fetchDealers = () => {
        return new Promise((resolve, reject) => {
          this.dealerSearch = this.dealerSearch ? this.dealerSearch : "";

          let params = {
            search: this.dealerSearch,
          };

          if (typeof this.tasks !== "undefined" && this.tasks === true) {
            params.purpose = "task_assignment";
          }

          api.dealersAutocomplete(params).then((resp) => {
            resp.data.results.forEach((element) => {
              if (
                !this.dealerOptions.find((el) => el.uuid == element.uuid) &&
                !restrictions.isCrmGroupSuperGroup(element.uuid)
              ) {
                this.dealerOptions.push(element);
              }
            });

            if (this.selectFirst && this.dealerOptions.length === 1) {
              this.dealer = this.dealerOptions[0];
            }
            resolve();
          });
        });
      };

      if (initalLoad) return fetchDealers();

      if (this.timeout) clearTimeout(this.timeout);

      this.timeout = setTimeout(() => {
        return fetchDealers();
      }, 300);
    },
  },
};
</script>
